import { createAction } from '@reduxjs/toolkit';

const deleteCollectionsById = createAction('archive/deleteCollectionsById');

export default deleteCollectionsById;
